__turbopack_context__.v({
  "changelogContainer": "ChangeLog-module__Woauiq__changelogContainer",
  "newIndicator": "ChangeLog-module__Woauiq__newIndicator",
  "pulse": "ChangeLog-module__Woauiq__pulse",
});
